export default "__VITE_ASSET__15LVXTyI__"